import { createReducer, on } from '@ngrx/store';
import { SocketActions } from './socket.actions';
import { initialSocketState, SocketState } from './socket.state';

export const socketReducer = createReducer(
  initialSocketState,

  on(SocketActions.connect, (state): SocketState => ({
    ...state,
    status: 'connecting',
    error: null,
  })),

  on(SocketActions.connected, (state): SocketState => ({
    ...state,
    status: 'connected',
    error: null,
  })),

  on(SocketActions.reconnecting, (state): SocketState => ({
    ...state,
    status: 'reconnecting',
    error: null,
  })),

  on(SocketActions.disconnect, (state): SocketState => ({
    ...state,
    status: 'disconnected',
    channels: [],
  })),

  on(SocketActions.disconnected, (state): SocketState => ({
    ...state,
    status: 'disconnected',
  })),

  on(SocketActions.subscribe, (state, { channel }): SocketState => ({
    ...state,
    channels: state.channels.includes(channel)
      ? state.channels
      : [...state.channels, channel],
  })),

  on(SocketActions.unsubscribe, (state, { channel }): SocketState => ({
    ...state,
    channels: state.channels.filter((x) => x !== channel),
  })),

  on(SocketActions.messageReceived, (state, { message }): SocketState => ({
    ...state,
    lastMessage: message,
  })),

  on(SocketActions.error, (state, { error }): SocketState => ({
    ...state,
    status: 'error',
    error,
  })),
);